import LOGINBACKGROUND from '../../../../images/login-background.svg'

const ismobile= window.matchMedia("(max-width:768px)").matches;

export const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    fontFamily: 'Roboto, sans-serif',
  },
  header: {
    textAlign: 'center',
    padding: '0px',
    color: '#fff',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: '16px',
  },
  main: {

    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
    padding: '20px 0px 20px 0px',
    backgroundPosition: 'bottom',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundImage: `url(${LOGINBACKGROUND})`,
    height: "100%",
    width: "100%",
    alignItems: "center",
    flex:1
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: ismobile?"1rem":"9rem",
 
  },
  boxLogin: {
    // flex: '1 1 300px',
    // maxWidth: '400px',
    height: 'fit-content',
    backgroundColor: '#fff',
    // padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    marginTop: "30px"

  },
  main1: {

    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
    padding: '20px 0px 20px 0px',
    backgroundImage: `url(${LOGINBACKGROUND})`,
    backgroundSize: { lg: 'cover', md: 'cover', sm: "repeat", xs: "repeat" },
    backgroundPosition: 'bottom',
    height: "100%",
    width: "100%",
    alignItems: "center",
  }
};